// removed by extract-text-webpack-plugin
module.exports = {"disclaimerDoc":"src-components-ExternalInvest-components-___DocumentOption__disclaimerDoc___1d-QB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExternalInvest/components/DocumentOption.css
// module id = 1241
// module chunks = 3